import classNames from 'classnames';
import { Select } from 'lego-on-react';
import { uniqueId } from 'lodash';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { Item } from '../EasyFilters';

export interface EasySelectProps {
    items: Item[] | undefined;
    name: string;
    value: string[] | string;
    cls?: string;
    optionalPlaceHolder?: boolean;
    text?: string;
    onChange: (val: string | string[] | boolean, name: string) => void;
    anchor?: HTMLDivElement;
}

export class EasySelect extends React.Component<EasySelectProps> {
    constructor(props: EasySelectProps) {
        super(props);
    }

    render(): React.ReactNode {
        const { cls, value, anchor } = this.props;
        const placeHolder = this.getPlaceHolder();

        return (
            <Select
                {...this.props}
                cls={classNames(cls, Bem.cls('easy-filters', 'filter'))}
                theme="normal"
                size="s"
                type="radiocheck"
                text={placeHolder}
                val={value}
                placeholder={placeHolder}
                popup={{
                    scope: anchor
                }}
                key={uniqueId('filter')}
                onChange={this.onFilterChange}
            />
        );
    }

    private getPlaceHolder = (): string => {
        const { text, value, optionalPlaceHolder, items } = this.props;
        const filterValue =
            items &&
            items
                .filter((item: Item) => value.includes(item.val))
                .map((item: Item) => item.text)
                .join(', ');

        if (optionalPlaceHolder && text && filterValue) {
            return text + ': ' + filterValue;
        } else if (filterValue) {
            return filterValue;
        } else if (text) {
            return text;
        } else {
            return '—';
        }
    };

    private onFilterChange = (value: string) => {
        const { onChange, name } = this.props;

        onChange(value, name);
    };
}
